export default __webpack_public_path__ + "static/media/TDT-Logo-Color.04921f2f.svg";